module.exports = __webpack_public_path__ + "img/calendar-icon.7e4f6341.svg";